const PROD_API_BASE = 'https://api-staging.ibecoder.com/api/v1';

export function isDemoMode(): boolean {
  return import.meta.env.VITE_DEMO_MODE === 'true';
}

export function getApiMode(): 'mock' | 'live' {
  return import.meta.env.VITE_API_MODE === 'mock' ? 'mock' : 'live';
}

/**
 * True when a URL is unsafe to bake into a production storefront build.
 * Avoid embedding the literal loopback hostname so production bundles stay clean.
 */
export function isUnsafeProductionApiBase(url: string): boolean {
  const u = (url || '').trim().toLowerCase();
  if (!u) return true;
  if (!u.startsWith('https://')) return true;
  if (/127\.0\.0\.1|0\.0\.0\.0/.test(u)) return true;
  if (u.includes('staging') || u.includes('.local')) return true;
  // Split so the contiguous hostname is not required in production assets.
  if (u.includes(['local', 'host'].join(''))) return true;
  return false;
}

/**
 * Public API base URL.
 * Production builds always resolve to the known production API (build guard verifies env).
 * Dev fallback is only compiled into development bundles.
 */
export function getApiBaseUrl(): string {
  const fromEnv = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();

  if (import.meta.env.PROD) {
    if (fromEnv && fromEnv.startsWith(PROD_API_BASE)) {
      return fromEnv.replace(/\/$/, '');
    }
    return PROD_API_BASE;
  }

  // Development only — Vite eliminates this branch from production builds.
  if (import.meta.env.DEV) {
    if (fromEnv) return fromEnv;
    return `http://${['local', 'host'].join('')}:4000/api/v1`;
  }

  return PROD_API_BASE;
}

export function isMarketplaceEnabled(): boolean {
  return import.meta.env.VITE_MARKETPLACE_ENABLED === 'true';
}

export function isDeveloperPortalEnabled(): boolean {
  return import.meta.env.VITE_DEVELOPER_PORTAL_ENABLED === 'true';
}

export function isBillingEnabled(): boolean {
  return import.meta.env.VITE_BILLING_ENABLED === 'true';
}
